<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot></slot>
      </span>
    </template>
    <fs1-span>{{ text }}</fs1-span>
  </v-tooltip>
</template>

<script>
export default { props:['text'] };
</script>
